module.exports = __webpack_public_path__ + "static/media/IMG_20200616_113102.5db1a44a.webp";